import React, { Component } from 'react'

export default class Portfolio extends Component {
    render() {
        return (
            <section className="portfolio" id="portfolio">
                <div className="container">
                    <div className="section-heading">
                        <h1> Portfolio</h1>
                        <h6>Most of the applications I made used confidential data but here is a quick description of what I did.</h6>
                    </div>
                    <div className="portfolio-item">
                        <div className="portfolio-img has-margin-right">  
                            <h1> Dashboard development</h1>
                            <h1> Dashboard development</h1> 
                        </div>
                        <div className="portfolio-description">
                            <h1>Data Analysis</h1>
                            <p> Building dashboard applications for Pipeline laying activities.These dashboards help to follow-up the prodcution, 
                                make analysis of the laying rates (Number of welds rejected and accepted per day).<br/>
                                This dashboard also helps to understand what kind of defects are produced on the 
                                pipeline welds and compare them to the Engineering Critical Assessment Acceptance Criteria (which is basically an Infinite Elements 
                                calculation which determines what size of flaws can be accepted inside a weld)
                            </p>
                        </div>
                    </div>

                    <div className="portfolio-item">
                        <div className="portfolio-description has-margin-right">
                            <h1>Defectology on Pipeline Welds</h1>
                            <p> 
                                The biggest challenge of pipeline welding is to understand upstream of production what situation we can faced depending on what we call 
                                a "welding configuration". This weld configuration is determined by a lot of parameters : Material grade, material ultrasonic properties, 
                                welding process, pipe thickness, vessel used for laying and etc... <br/>
                                The idea behind the tool is to use data coming from past projects to understand the behavior of welding processes on specific configurations 
                                (to basically avoid to use any unfit welding process for an offshore production). Offshore campaign are expensive thus, welding processes must
                                be reliable and fast for the related scope of work.<br/>
                                With this tool we can already predict during tendering phase with client what welding process shall be used and therefore have quick statistics
                                on our performance. Like so, we know what processes should be elected to satifsy client specification and lay faster.
                            </p>
                        </div>
                        <div className="portfolio-img">
                            <h1> Predictive Analysis and Machine Learning</h1>
                            <h1> Predictive Analysis and Machine Learning</h1>
                        </div>
                    </div>

                    <div className="portfolio-item">
                        <div className="portfolio-img has-margin-right">
                            <h1> Application Programming Interface </h1>
                            <h1> Application Programming Interface </h1>
                            
                        </div>
                        <div className="portfolio-description">
                            <h1>Gathering data coming from offshore</h1>
                            <p> Based on an R&D tools made in colaboration with another Company we are now able to gather data coming directly from AUT systems. These data are 
                                gathered into a database and then need to be put into a REST API for use of other applications such as the ones described above.
                                All raw data are stored into a PostreSQL database, then any simulation or calculation are placed into an API for users.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
